import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSelfCrmUserPastComments,
  getSelfPastComments,
} from "../actions/userAction";
import moment from "moment";

export default function SelfPastComments(props) {
  const dispatch = useDispatch();
  const [contactId2, setContactId2] = useState(0);
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  const guestPastComments = useSelector((state) => state.guestPastComments);
  const { loading, error, pastComments } = guestPastComments;

  useEffect(() => {
    // if (dataa == undefined || dataa.length == 0) {
    if (
      pastComments == undefined ||
      pastComments.length == 0 ||
      contactId2 !== props.contactId
    ) {
      if (guestCrm) {
        dispatch(getSelfCrmUserPastComments(props.commentJson));
      } else {
        dispatch(getSelfPastComments(props.commentJson));
      }

      setContactId2(props.contactId);
    } else {
    }
  }, [pastComments, props.contactId]);
  return (
    <>
      {loading ? (
        <>Loading ...</>
      ) : (
        <>
          {error ? (
            <>{error}</>
          ) : (
            <>
              {pastComments ? (
                <>
                  {pastComments.map((record) => (
                    <div className="card-body">
                      <div className="comment-content bg-white p-2">
                        <div className="d-flex flex-row user-info">
                          <img
                            className="rounded-circle"
                            src="assets/img/Deafult-user.png"
                            alt=""
                            width="40"
                          />
                          <div className="d-flex flex-column justify-content-start ml-2">
                            <span className="d-block font-weight-bold name">
                              {record.Guest_Name || record?.First_Name}
                            </span>
                            <span className="date text-black-50">
                              {record.Institute} -{" "}
                              {moment(record.Created_On).format()}
                            </span>
                          </div>
                        </div>
                        <div className="mt-2">
                          <p className="comment-text">{record.Comment}</p>
                          <div style={{display:"flex",justifyContent:"flex-end"}}>
                            {record?.Contact_Type ? (
                              <p className="contact_t">
                                {record?.Contact_Type}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
